<template>
  <div class="c-textarea">
    <div class="c-textarea__title">認証情報<br />（サービスアカウント）</div>
    <div class="c-textarea__item_wrapper u-w680">
      <div class="c-radio u-w100p u-h60p">
        <div class="c-error c-error--balloon" :class="{ 'is-active': errorMessage !== '' }">
          <div class="c-error__text">{{ errorMessage }}</div>
        </div>
      </div>
      <textarea
        v-model="dataValue"
        class="c-textarea__item u-w630 u-h100"
        :disabled="!isEditable"
        :style="isEditable ? '' : 'background-color: #f6f6f6;'"
        @change="valueChanged"
      ></textarea>
    </div>
    <button
      v-show="isEditable"
      class="c-btn c-btn--circle"
      type="button"
      name="clip"
      value="add-user"
      @click="onClick"
    >
      <div class="c-btn__text c-btn__text--balloon">
        サービスアカウントからコピー
      </div>
      <div class="c-icon-circle c-icon-circle--gray-2 u-wh40">
        <div
          class="
            c-icon-circle__item c-icon-circle__item--white
            c-icon__item--alpha70
            u-wh20
          "
        >
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <use xlink:href="/assets/img/sprite.svg#plus" />
          </svg>
        </div>
      </div>
    </button>
    <input
      id="service_account_key_file_input"
      type="file"
      style="display: none"
      accept="application/json"
      @change="onServiceAccountFileChange"
    />
  </div>
</template>
<script>
export default {
  props: {
    inputName: String,
    title: String,
    serviceAccountKey: String,
    data: [String, Number],
    placeholder: String,
    errorMessage: {
      type: String,
      default: "",
    },
    type: Number,
    isProduction: Boolean,
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["service-account-changed"],
  data() {
    return {
      dataValue: this.serviceAccountKey || '',
    };
  },
  computed: {
  },
  methods: {
    onClick: function () {
      window.document.getElementById("service_account_key_file_input").click();
    },
    onServiceAccountFileChange: function (event) {
      const self = this;
      // ファイルが選択されていない場合（キャンセル時など）は処理を終了
      if (!event.target.files || !event.target.files.length) {
        return;
      }
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      // JSONファイルのみを許可
      if (file.type !== "application/json") {
        console.warn("選択されたファイルはJSONファイルではありません:", file.type);
        return;
      }
      const fileReader = new FileReader();

      fileReader.onload = () => {
        this.dataValue = fileReader.result;
        self.valueChanged();
        // input要素をリセットして次回の選択に備える
        event.target.value = '';
      };
      fileReader.readAsText(file);
    },
    valueChanged: function () {
      const self = this;
      this.$nextTick(function () {
        this.$emit("service-account-changed", self.dataValue);
      });
    },
  },
};
</script>
